import { ButtonLink, ButtonLinkProps } from 'src/components/atoms/Link'

export const CallToActionButtonLink = ({
  size = 'large',
  ...props
}: ButtonLinkProps) => {
  return <ButtonLink {...props} size={size} />
}
